import React, { useState } from 'react';
import Footer from './Footer';
import Header from './Header';
// import { FaChevronRight } from 'react-icons/fa'; // Font Awesome icon alternative using react-icons

export default function Projects() {
  const [filter, setFilter] = useState('all');

  // Updated structured projects by category with real project names
  const projects = [
    {
      title: 'Educational',
      items: [
        'Alkimos North East Primary School',
      'Banksia Grove West Primary School',
      'Byford Secondary College',
      'Springfield Primary School',
      'Wellard Primary School',
      'Eglinton Primary School',
      'Brabham East Primary School',
      'Mount Lawley Senior High School',
      'Wattleup East Primary School',
      'Madora Bay Primary School',
      'Kyilla Primary School',
      'Landsdale Primary School',
      'Arbor Grove Primary School – Refurbishment',
      'Southern River Primary School',
      'Brabham Primary School',
      'Banksia Grove East Primary School',
      'Byford South East Primary School',
      'Baldivis North Primary School',
      'North Morley Primary School',
      'Pine View Primary Education Support Centre Hub',
      'Kinross Primary School',
      'Mount Claremont Primary School – Admin Upgrade',
      'Seaforth Primary School – Admin Upgrade'
      ]
    },
    {
      title: 'Apartments',
      items: [
        'Saunton Apartments, Jindalee',
        'Bunbury Apartments'
      ]
    },
    {
      title: 'Aged Care',
      items: [
        'Narrogin Cottage Homes',
        'MercyCare Aged Care, Edgewater'
      ]
    },
    {
      title: 'Restaurants',
      items: [
        'Pretty Pool Café, Port Hedland',
      'Monelli Italian Fine Dining, Burns Beach',
      'Ocean 205, Bunbury'
      ]
    },
    {
      title: 'Place Of Worship',
      items: [
        'Kingdom of Light Church, Cockburn Central',
      "St. Peter's Jacobite Church, Wattle Grove",
      'Carmel Bible Church, Willetton',
      'Perth Pentecostal Assembly, Bibra Lake'
      ]
    },
    
    {
      title: 'Design & Construct',
      items: [
       'Yara Tan Burrup Ammonium Nitrate Facility, Karratha',
      'Monelli Italian Fine Dining, Burns Beach',
      'Ocean 205, Bunbury',
      'Paraburdoo Child Care Centre',
      'Coventry Office Expansion, Redcliffe',
      'Freedom Furniture Showroom, Osborne Park',
      'Officeworks, Osborne Park',
      'Toyota & Holden Showroom, Broome',
      'Jeep Showroom, Rockingham',
      'Greyhounds Pavilion, Cannington',
      "St. Peter's Jacobite Church, Wattle Grove",
      'Carmel Bible Church, Willetton',
      'Perth Pentecostal Assembly, Bibra Lake'
      ]
    },
    {
      title: 'Other',
      items: [
        'Yara Tan Burrup Ammonium Nitrate Facility, Karratha',
      'BHP Macedon Permanent Buildings, Onslow',
      'Newman Arts Centre, Newman',
      'Newman Airport Expansion, Newman',
      'Main Roads, Narrogin',
      'Main Roads, Northam',
      'Netball Pavilion, South Hedland',
      'Paraburdoo Child Care Centre',
      'Coventry Office Expansion, Redcliffe',
      'Freedom Furniture Showroom, Osborne Park',
      'Officeworks, Osborne Park',
      'Transportable School Buildings',
      'Yanchep Active Open Space, Yanchep',
      'Pingelly Recreation Centre, Pingelly',
      'Greyhounds Pavilion, Cannington',
      'Seville Grove Library & Champion Centre',
      'Northline Distribution Centre, Kenwick',
      'Goodlife Gym, Joondalup',
      'EPIC Community Centre, Karratha',
      'Cannington/Welshpool SER/TSER Buildings (Armadale Line Upgrade)',
      "Ingham's Chicken Facility, Osborne Park",
      'Hazelmere Resource Recovery Park',
      'Kelmscott Hall Upgrade',
      'Surfing WA Headquarters, Trigg',
      'Wellington Post Office, Perth'
      ]
    },
  ];

  const filters = ['all', 'Educational', 'Restaurants', 'Place Of Worship', 'Apartments', 'Aged Care',  'Design & Construct','Other'];

  const filteredProjects =
    filter === 'all' ? projects : projects.filter(p => p.title === filter);

  return (
    <div>
      <Header />

      <div className="page_title projectspage">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h5 className="page_tittle activeColor text-center text-uppercase">
                Projects
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div className="project-section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-12">

              {/* Filter Buttons */}
              <div className="inner-mixitup-menus text-center mb-4">
                {filters.map(f => (
                  <button
                    key={f}
                    className={`btn btn-primary filter-btn mb-2 mb-md-0 ${filter === f ? 'active' : ''}`}
                    onClick={() => setFilter(f)}
                    type="button"
                  >
                    {f === 'all' ? 'View All' : f}
                  </button>
                ))}
              </div>

              {/* Projects Grid */}
              <div className="row" id="mixitup-projects">
                {filteredProjects.map((project, idx) => (
                  <div key={idx} className="col-12 col-md-6 col-lg-4 mb-4">
                    <div className="card border-0 rounded-0 h-100 shadow-sm" style={{background: 'beige'}}>
                      <div className="card-body" >
                        <h5 className="card-title"> {(project.title == "Educational" || project.title == "Other" || project.title == "Design & Construct")  ? `${project.title} Projects` : project.title} </h5>
           
                        <ul className="list-unstyled mt-3">
                          {project.items.map((item, i) => (
                            <li key={i} className="mb-2 d-flex align-items-start">
                              <i className="fa fa-check-circle me-2 text-primary" style={{marginRight:'2%'}}></i>
                              <span>{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>

            {/* Pagination (Optional, left untouched) */}
            {/* <div className="col-md-12">
              <div className="d-flex justify-content-center pagination_waper">
                <nav aria-label="Page navigation ct-pagination">
                  <ul className="pagination">
                    <li className="page-item">
                      <a className="page-link pt-0 pb-0 rounded-0 activeColor" href="#" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                        <span className="sr-only">Previous</span>
                      </a>
                    </li>
                    <li className="page-item"><a className="page-link pt-0 pb-0 rounded-0 text-dark" href="#">1</a></li>
                    <li className="page-item"><a className="page-link pt-0 pb-0 rounded-0 text-white activeBg activeborder" href="#">2</a></li>
                    <li className="page-item"><a className="page-link pt-0 pb-0 rounded-0 text-dark" href="#">3</a></li>
                    <li className="page-item">
                      <a className="page-link pt-0 pb-0 rounded-0 activeColor" href="#" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                        <span className="sr-only">Next</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div> */}

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
